import   React                 ,  
       { useState              ,
         useEffect             }  from 'react';

// import { useNavigate           }  from 'react-router-dom';
// import { Dispatch              }  from 'redux';
// import { useDispatch           }  from 'react-redux';

import   classNames               from 'classnames';

import   styles                   from './LegalStructureSheet.module.scss';

import   Field                    from '../../widget/inputs/Field';
import   TextArea                 from '../../widget/inputs/TextArea';
import   Select                   from '../../widget/inputs/Select';
import   WidgetFrame              from '../../widget/navigation/WidgetFrame';
import   Window                   from '../../widget/windows/window';
import   Trigger                  from '../../widget/actuators/Trigger';
import   TabularDisplay           from "../../widget/dataDisplay/tables/TabularDisplay";
import   Icon                     from "../../widget/images/Icon";

import { LegalStructure ,
         initializedLegalStructure,
		 StaffMember,
         BusinessDocument}                   from '../../../dataTypes/legalStructureManagment/types';


import { User } from '../../../dataTypes/userManagment/types';

import { Admin } from '../../../dataTypes/adminManagment/types';


import { getAdmins } from '../../../backendServices/adminManagment/api';

import { createLegalStructure } from '../../../backendServices/legalStructureManagment/api_legalStructure';

import { groupData                        ,
         GroupedData                      ,
         initializedGroupedData                }  from "../../../dataTypes/dataSetManagment/regroupData";
/*
import { Validation            ,
         checkFirstname        ,
         checkLastname         ,
         checkSex              ,
         checkBirthday         ,
         checkAddress          ,
         checkAddress2         ,
         checkZipCode          ,
         checkCity             ,
         checkCountry          ,
         checkPhoneNumber      } from '../../../dataTypes/userManagment/validators';
*/

//import { patchUser }  from '../../../backendServices/userManagment/api';

import   StaffMemberSheet               from './StaffMemberSheet';
import   BusinessDocumentSheet          from './BusinessDocumentSheet';

type LegalStructureSheetProps = {
  users             : User[] ;
  legalStructure?   : LegalStructure ;
  creationMode?     : boolean        ;
  onCreationCancel? : () => void
  onCreationMade?   : () => void
}

export const LegalStructureSheet = ({ users            ,
                                      legalStructure   ,
                                      creationMode     ,
                                      onCreationCancel ,
									  onCreationMade   }: LegalStructureSheetProps) => {

  const defaultLegalStructure = initializedLegalStructure ()

  const [                                           , setAdmins                                          ] = useState<Admin[]>([])
  const [ adminIds                                        , setAdminIds                                        ] = useState<string[]>([])
  const [ adminNames                                      , setAdminNames                                      ] = useState<string[]>([])

  const [ tradeName                                       , setTradeName                                       ] = useState ( legalStructure?.tradeName                                ?? defaultLegalStructure.tradeName                                );
  const [ companyName                                     , setCompanyName                                     ] = useState ( legalStructure?.companyName                              ?? defaultLegalStructure.companyName                              );
  const [ legalForm                                       , setLegalForm                                       ] = useState ( legalStructure?.legalForm                                ?? defaultLegalStructure.legalForm                                );
  const [ businessRegistrationNumber                      , setBusinessRegistrationNumber                      ] = useState ( legalStructure?.businessRegistrationNumber               ?? defaultLegalStructure.businessRegistrationNumber               );
  const [ businessActivityCode                            , setBusinessActivityCode                            ] = useState ( legalStructure?.businessActivityCode                     ?? defaultLegalStructure.businessActivityCode                     );
  const [ businessSector                                  , setBusinessSector                                  ] = useState ( legalStructure?.businessSector                           ?? defaultLegalStructure.businessSector                           );
  const [ businessActivityDetails                         , setBusinessActivityDetails                         ] = useState ( legalStructure?.businessActivityDetails                  ?? defaultLegalStructure.businessActivityDetails                  );
  const [ address                                         , setAddress                                         ] = useState ( legalStructure?.address                                  ?? defaultLegalStructure.address                                  );
  const [ address2                                        , setAddress2                                        ] = useState ( legalStructure?.address2                                 ?? defaultLegalStructure.address2 );
  const [ address3                                        ] = useState ( legalStructure?.address3                                 ?? defaultLegalStructure.address3 );
  const [ zipCode                                         , setZipCode                                         ] = useState ( legalStructure?.zipCode                                  ?? defaultLegalStructure.zipCode );
  const [ city                                            , setCity                                            ] = useState ( legalStructure?.city                                     ?? defaultLegalStructure.city );
  const [ country                                         , setCountry                                         ] = useState ( legalStructure?.country === "" ? "France" : (legalStructure?.country ?? "France") );
  const [ phoneNumber                                     , setPhoneNumber                                     ] = useState ( legalStructure?.phoneNumber                              ?? defaultLegalStructure.phoneNumber );
  const [ administrativeValidationDate                    , setAdministrativeValidationDate                    ] = useState ( legalStructure?.administrativeValidationDate             ?? defaultLegalStructure.administrativeValidationDate );
  const [                  , setAdministrativeValidationAgentId                 ] = useState ( legalStructure?.administrativeValidationAgentId          ?? defaultLegalStructure.administrativeValidationAgentId );
  const [                          , setFinancialValidationDate                         ] = useState ( legalStructure?.financialValidationDate                  ?? defaultLegalStructure.financialValidationDate );
  const [                       , setFinancialValidationAgentId                      ] = useState ( legalStructure?.financialValidationAgentId               ?? defaultLegalStructure.financialValidationAgentId );
  const [                  , setFinancialValidationBalanceValue                 ] = useState ( legalStructure?.financialValidationBalanceValue          ?? defaultLegalStructure.financialValidationBalanceValue );
  const [         , setFinancialValidationBalanceExpirationDate        ] = useState ( legalStructure?.financialValidationBalanceExpirationDate ?? defaultLegalStructure.financialValidationBalanceExpirationDate );
  const [ contacts                                        , setContacts                                        ] = useState ( legalStructure?.staffMembers                             ?? defaultLegalStructure.staffMembers );
  const [ documents                                       , setDocuments                                       ] = useState ( legalStructure?.businessDocuments                        ?? defaultLegalStructure.businessDocuments );

  const [ handledByAgentId                                , setHandledByAgentId                                ] = useState ( legalStructure?.handledByAgentId                         ?? defaultLegalStructure.handledByAgentId )
  const [ VATnumber                                       , setVATnumber                                       ] = useState ( legalStructure?.VATnumber                                ?? defaultLegalStructure.VATnumber )

  const [ contactsTab                                     , setContactsTab                                     ] = useState<GroupedData<StaffMember>>(initializedGroupedData<StaffMember>())
  const [ documentsTab                                    , setDocumentsTab                                    ] = useState<GroupedData<BusinessDocument>>(initializedGroupedData<BusinessDocument>())
  const [ tableHeight              ] = useState (300);

  const [ messageTradeName                                , setMessageTradeName                                ] = useState ( '' );
  const [ messageCompanyName                              , setMessageCompanyName                              ] = useState ( '' );
  const [ messageLegalForm                                , setMessageLegalForm                                ] = useState ( '' );
  const [ messageBusinessRegistrationNumber               , setMessageBusinessRegistrationNumber               ] = useState ( '' );
  const [ messageBusinessActivityCode                     , setMessageBusinessActivityCode                     ] = useState ( '' );
  const [ messageBusinessSector                           , setMessageBusinessSector                           ] = useState ( '' );
  const [ messageBusinessActivityDetails                  , setMessageBusinessActivityDetails                  ] = useState ( '' );
  const [ messageAddress                                  , setMessageAddress                                  ] = useState ( '' );
  const [                                  , setMessageAddress2                                 ] = useState ( '' );
  const [ messageZipCode                                  , setMessageZipCode                                  ] = useState ( '' );
  const [ messageCity                                     , setMessageCity                                     ] = useState ( '' );
  const [ messageCountry                                  , setMessageCountry                                  ] = useState ( '' );
  const [ messagePhoneNumber                              , setMessagePhoneNumber                              ] = useState ( '' );
  const [              , setMessageAdministrativeValidationDate             ] = useState ( '' );
  const [           , setMessageAdministrativeValidationAgentId          ] = useState ( '' );
  const [ messageFinancialValidationDate                  , setMessageFinancialValidationDate                  ] = useState ( '' );
  const [                , setMessageFinancialValidationAgentId               ] = useState ( '' );
  const [           , setMessageFinancialValidationBalanceValue          ] = useState ( '' );
  const [ messageFinancialValidationBalanceExpirationDate , setMessageFinancialValidationBalanceExpirationDate ] = useState ( '' );
  
  const [ messageHandledByAgentId                                , setMessageHandledByAgentId                                ] = useState ('')
  const [ messageVATnumber                                       , setMessageVATnumber                                       ] = useState ('')


  const [ editMode                                        , setEditMode                                        ] = useState ( creationMode ?? false )
  const [ showWindow                                      , setShowWindow                                      ] = useState ( false );
  const [ windowMessage                                   , setWindowMessage                                   ] = useState ( <></> );

  const [ staffMemberSheetShow , setStaffMemberSheetShow ] = useState (false)
  const [ businessDocumentSheetShow , setBusinessDocumentSheetShow ] = useState (false)

  const [                                    , setIsSmallScreen                                   ] = useState<boolean>(false);

  const switchWidthLimit = 870;

  const handleResize = () => {
    setIsSmallScreen ( window.innerWidth <= switchWidthLimit );
  };


  useEffect(() => {

    console.log (legalStructure)

    window.addEventListener('resize', handleResize);

    handleResize();

    init ()

    console.log ( administrativeValidationDate, messageFinancialValidationDate, messageFinancialValidationBalanceExpirationDate )


    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []); 

  useEffect(() => {

    generateContactsTab ()

  }, [contacts]); 

  useEffect(() => {

    generateDocumentsTab ()

  }, [documents]);


  const init = async () => {
	  
	const adminsResult = await getAdmins()
	
	if ( adminsResult.code === 1 )
	 {
	  setAdmins ( adminsResult.payload )
	  
	  let ids   : string [] =[]
	  let names : string [] =[]
	  
	  adminsResult.payload.map ( (admin) => {
		  
		ids.push ( `${admin.id}` )
        names.push ( `${admin.firstname} ${admin.lastname}` )		
	  }) 
	  
	  console.log ( ids, names )
	  
	  setAdminIds   ( ids   )
	  setAdminNames ( names )
	 }	  
	  
  }

  const handleTradeNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setTradeName ( e.target.value )
  };

  const handleCompanyNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setCompanyName ( e.target.value )
  };

  const handleLegalFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setLegalForm ( e.target.value )
  };

  const handleBusinessRegistrationNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setBusinessRegistrationNumber ( e.target.value )
  };

  const handleBusinessActivityCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setBusinessActivityCode ( e.target.value )
  };

  const handleBusinessSectorChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setBusinessSector ( e.target.value )
  };

  const handleBusinessActivityDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setBusinessActivityDetails ( e.target.value )
  };

  const handleAddressChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {

    setAddress    ( e.target.value )

    // const retour: Validation = checkAddress  ( e.target.value )
    // setMessageAddress ( retour.comment );
  };


  const handleZipCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setZipCode    ( e.target.value )

    // const retour: Validation = checkZipCode  ( e.target.value )
    // setMessageZipCode ( retour.comment );
  };

  const handleCityChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setCity    ( e.target.value )

    // const retour: Validation = checkCity  ( e.target.value )
    // setMessageCity ( retour.comment );
  };

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    setCountry    ( e.target.value )

    // const retour: Validation = checkCountry  ( e.target.value )
    // setMessageCountry ( retour.comment );
  };

  const handlePhoneNumberChange = async (e: React.ChangeEvent<HTMLInputElement>) => {

    setPhoneNumber    ( e.target.value )

    // const retour: Validation = await checkPhoneNumber  ( e.target.value , user.email )
    // setMessagePhoneNumber ( retour.comment );
  };







  const handlehandledByAgentIdChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    setHandledByAgentId ( parseInt ( e.target.value ) )
  };

  const handleVATnumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setVATnumber ( e.target.value )
  };


  const handleStaffMemberSheetHide = () => {
    setStaffMemberSheetShow(false);
  }


  const handleBusinessDocumentSheetHide = () => {
    setBusinessDocumentSheetShow(false);
  }





  const generateContactsTab = () => {

    const groupKey = (contact: StaffMember) => ({
                                                  key      : `${contact.userId}`,
                                                  renderer : (val: string) => val,
                                               })

    const groupedDataLocal = groupData<StaffMember> ( contacts, groupKey );
	
	setContactsTab (groupedDataLocal)
  }

  const generateDocumentsTab = () => {

    const groupKey = (document: BusinessDocument) => ({
                                                        key      : `${document.id}`,
                                                        renderer : (val: string) => val,
                                                     })

    const groupedDataLocal = groupData<BusinessDocument> ( documents, groupKey );

	setDocumentsTab (groupedDataLocal)
  }

  const handleEditButtonClick = () => {

    if (editMode)
     {
      setTradeName                                       ( legalStructure?.tradeName                                ?? defaultLegalStructure.tradeName );
      setCompanyName                                     ( legalStructure?.companyName                              ?? defaultLegalStructure.companyName );
      setLegalForm                                       ( legalStructure?.legalForm                                ?? defaultLegalStructure.legalForm );
      setBusinessRegistrationNumber                      ( legalStructure?.businessRegistrationNumber               ?? defaultLegalStructure.businessRegistrationNumber );
      setBusinessActivityCode                            ( legalStructure?.businessActivityCode                     ?? defaultLegalStructure.businessActivityCode );
      setBusinessSector                                  ( legalStructure?.businessSector                           ?? defaultLegalStructure.businessSector );
      setBusinessActivityDetails                         ( legalStructure?.businessActivityDetails                  ?? defaultLegalStructure.businessActivityDetails );
      setAddress                                         ( legalStructure?.address                                  ?? defaultLegalStructure.address );
      setAddress2                                        ( legalStructure?.address2                                 ?? defaultLegalStructure.address2 );
      setZipCode                                         ( legalStructure?.zipCode                                  ?? defaultLegalStructure.zipCode );
      setCity                                            ( legalStructure?.city                                     ?? defaultLegalStructure.city );
      setCountry                                         ( legalStructure?.country === "" ? "France" : (legalStructure?.country ?? "France") );
      setPhoneNumber                                     ( legalStructure?.phoneNumber                              ?? defaultLegalStructure.phoneNumber );
      setAdministrativeValidationDate                    ( legalStructure?.administrativeValidationDate             ?? defaultLegalStructure.administrativeValidationDate );
      setAdministrativeValidationAgentId                 ( legalStructure?.administrativeValidationAgentId          ?? defaultLegalStructure.administrativeValidationAgentId );
      setFinancialValidationDate                         ( legalStructure?.financialValidationDate                  ?? defaultLegalStructure.financialValidationDate );
      setFinancialValidationAgentId                      ( legalStructure?.financialValidationAgentId               ?? defaultLegalStructure.financialValidationAgentId );
      setFinancialValidationBalanceValue                 ( legalStructure?.financialValidationBalanceValue          ?? defaultLegalStructure.financialValidationBalanceValue );
      setFinancialValidationBalanceExpirationDate        ( legalStructure?.financialValidationBalanceExpirationDate ?? defaultLegalStructure.financialValidationBalanceExpirationDate );

      setHandledByAgentId                                ( legalStructure?.handledByAgentId                         ?? defaultLegalStructure.handledByAgentId )
      setVATnumber                                       ( legalStructure?.VATnumber                                ?? defaultLegalStructure.VATnumber )
  
      setMessageTradeName                                ( '' );
      setMessageCompanyName                              ( '' );
      setMessageLegalForm                                ( '' );
      setMessageBusinessRegistrationNumber               ( '' );
      setMessageBusinessActivityCode                     ( '' );
      setMessageBusinessSector                           ( '' );
      setMessageBusinessActivityDetails                  ( '' );
      setMessageAddress                                  ( '' );
      setMessageAddress2                                 ( '' );
      setMessageZipCode                                  ( '' );
      setMessageCity                                     ( '' );
      setMessageCountry                                  ( '' );
      setMessagePhoneNumber                              ( '' );
      setMessageAdministrativeValidationDate             ( '' );
      setMessageAdministrativeValidationAgentId          ( '' );
      setMessageFinancialValidationDate                  ( '' );
      setMessageFinancialValidationAgentId               ( '' );
      setMessageFinancialValidationBalanceExpirationDate ( '' );
      setMessageFinancialValidationBalanceValue          ( '' );
      setMessageHandledByAgentId                         ( '' )
      setMessageVATnumber                                ( '' )
     }

    setEditMode (!editMode);   
  }

  const handleValidateButtonClick = () => {

    if ( creationMode )
           makeSave ()
      else makeUpdate ();
  }

  const handleCancelButtonClick = () => {

    if ( creationMode )
           if (onCreationCancel) onCreationCancel ()
      else handleEditButtonClick ();
  }


  const handleCloseButtonClick = () => {

    setEditMode   (false);
    setWindowMessage ( <></>);
    setShowWindow ( false );

//     if ( expiredSession )
//      {
//       dispatch ( initUser   () );
//       dispatch ( initAuthentication (true) );
//       navigate ( `${INTERNAL_LINKS.Home}` );
//      }
  }

  const makeSave = async () => {

    const response = await createLegalStructure ( tradeName                                ,
                                                  companyName                              ,
                                                  legalForm                                ,
                                                  businessRegistrationNumber               ,
                                                  businessActivityCode                     ,
                                                  businessSector                           ,
                                                  businessActivityDetails                  ,
                                                  address                                  ,
                                                  address2                                 ,
                                                  address3                                 ,
                                                  zipCode                                  ,
                                                  city                                     ,
                                                  country                                  ,
                                                  phoneNumber                              ,
												  handledByAgentId                         ,
												  VATnumber                                ,
                                                /*  administrativeValidationDate             ,
                                                  administrativeValidationAgentId          ,
                                                  financialValidationDate                  ,
                                                  financialValidationAgentId               ,
                                                  financialValidationBalanceValue          ,
                                                  financialValidationBalanceExpirationDate ,*/
                                                  contacts                                 ,
                                                  documents                                );
												  
	if ( response.code === 1 )
	 {
      if ( onCreationMade )
	   {
		onCreationMade ()   
	   }
	 }		
	
  }

  const makeUpdate = async () => {

/*
    const check = await checkAll ()

    if ( check )
     {
 
      const response = await patchUser ( 
                                           // authentication.token      ,
                                         user.id           ,
                                         firstname    ,
                                         lastname     ,
                                         sex          ,
                                         birthday     ,
                                         address      ,
                                         address2     ,
                                         zipCode      ,
                                         city         ,
                                         country      ,
                                         phoneNumber  ,
										 status       ,
										 statusDeadline
                                       )


      switch ( response.code )
       {
        case 1    : setWindowMessage ( <>Les informations ont été mises à jour</> );
                    setShowWindow ( true );

                    break;

        // case -102 : setWindowMessage ( <>Votre session a expiré, veuillez vous reconnecter.</> );
                    // setShowWindow ( true );

                    // setExpiredSession (true);

                    // break;

        default   : setWindowMessage ( <>Le compte n'a pas pu être modifié car une erreur réseau est survenue</> );
                    setShowWindow ( true );

       }
     }
	 */
   }


  const handleContactAdding = (newStaffMember : StaffMember) => {

    setStaffMemberSheetShow(false);

    setContacts(prev => {

      const already = prev.some(c => c.userId === newStaffMember.userId);

      if (already)
       {
        setWindowMessage(<>Ce contact est déjà dans la liste.</>);
        setShowWindow(true);
        return prev;
       }

      return [...prev, newStaffMember];
    });

  }

  const onContactAdd = () => {

    setStaffMemberSheetShow(true);
  }

  const handleContactEdit = (contact: StaffMember) => {
    console.log('Éditer contact:', contact);
  };

  const handleContactDelete = (contact: StaffMember) => {
    console.log('Supprimer contact:', contact);
  };


  const renderContactsTab = () : JSX.Element => {

    const columns = [
      {
        header       : 'UserId',
        accessor     : 'userId' as keyof StaffMember,
//        cellRenderer : (value: any) => (<span onClick={() => handleSpanClick(value)} style={{ textDecoration: 'underline'  , cursor: 'pointer' }}>{value}</span>),
        width        : '50px'
      },
      {
        header       : 'Prénom',
        accessor     : 'firstname' as keyof StaffMember,
        width        : '200px'
      },
      {
        header       : 'Nom',
        accessor     : 'lastname' as keyof StaffMember,
        width        : '200px'
      },
      {
        header       : 'Titre',
        accessor     : 'jobTitle' as keyof StaffMember,
        width        : '200px'
      },
      {
        header       : 'Email',
        accessor     : 'email' as keyof StaffMember,
        width        : '400px'
      },
      {
        header       : 'Téléphone',
        accessor     : 'phoneNumber' as keyof StaffMember,
        width        : '150px'
      },
    ];
	
   const actions = {
        header   : 'Actions',
        width    : '150px',
        align    : 'center' as const,  
        renderer : ( contact   : StaffMember , 
		             rowIndex  : number           , 
					 groupKey? : string           ) => (  
    
	                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
			              <Icon name = "pen"        onClick={() => handleContactEdit(contact)}   color="#000000" hoverColor="#4421AA" />
                          <Icon name = "trashCan"   onClick={() => handleContactDelete(contact)} color="#000000" hoverColor="#4421AA" />
                        </div>
                     )
    }
	

    return (
             <>
               <div className={styles.header}>
                 <div className={styles.title}>Liste des contacts</div>
                 <div className={styles.icon}>
 <Trigger iconName   = "plus"
		  iconWidth  = {15}
          iconHeight = {15}
          onClick    = {onContactAdd} />
                 </div>
               </div>
               <div className={styles.wrapper} >
                 <div className={styles.container} style={{maxHeight: tableHeight}} >
                   {
                     contactsTab.groups.size > 0
                     ?
                     (
                        <TabularDisplay groupedData           = {contactsTab}
                                        columns               = {columns}
   										actionColumn          = {actions}
                                        defaultHighlightColor = "#4421AA"
                                        showGroupHeaders      = {false} />
                     )
                     :
                     (
                        <div className={styles.noData}>Aucun contact</div>
                     )
                   }
                 </div>
               </div>
             </>
           )
  }

  const handleDocumentAdding = (newBusinessDocument : BusinessDocument) => {

    setBusinessDocumentSheetShow(false);

    setDocuments(prev => {

      return [...prev, newBusinessDocument];
    });

  }

  const onDocumentAdd = () => {
	  
	 setBusinessDocumentSheetShow (true)
  }

  const handleDocumentEdit = (doc: BusinessDocument) => {
    console.log('Éditer document:', doc);
  };

  const handleDocumentDelete = (doc: BusinessDocument) => {
    console.log('Supprimer document:', doc);
  };

  const handleDocumentView = (doc: BusinessDocument) => {
    console.log('Voir détails document:', doc);
  };

  const handleDocumentDownload = (doc: BusinessDocument) => {
    console.log('Télécharger document:', doc);
  };

  const renderDocumentsTab = () : JSX.Element => {

    const columns = [
      {
        header   : 'Nom',
        accessor : 'name' as keyof BusinessDocument,
        width    : '250px'
      },
    ];

    const actions = {
        header   : 'Actions',
        width    : '150px',
        align    : 'center' as const,  
        renderer : ( doc       : BusinessDocument , 
		             rowIndex  : number           , 
					 groupKey? : string           ) => (  
    
	                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
			              <Icon name = "eye"        onClick={() => handleDocumentView(doc)}     color="#000000" hoverColor="#4421AA" />
			              <Icon name = "pen"        onClick={() => handleDocumentEdit(doc)}     color="#000000" hoverColor="#4421AA" />
                          <Icon name = "trashCan"   onClick={() => handleDocumentDelete(doc)}   color="#000000" hoverColor="#4421AA" />
                          <Icon name = "floppyDisk" onClick={() => handleDocumentDownload(doc)} color="#000000" hoverColor="#4421AA" />
                        </div>
                     )
    }
	
	
    return (
             <>
               <div className={styles.header}>
                 <div className={styles.title}>Liste des documents</div>
                 <div className={styles.icon}>
 <Trigger iconName   = "plus"
		  iconWidth  = {15}
          iconHeight = {15}
          onClick    = {onDocumentAdd} />
                 </div>
               </div>
               <div className={styles.wrapper} >
                 <div className={styles.container} style={{maxHeight: tableHeight}} >
                   {
                     documentsTab.groups.size > 0
                     ?
                     (
                        <TabularDisplay groupedData           = {documentsTab}
                                        columns               = {columns}
										actionColumn          = {actions}
                                        defaultHighlightColor = "#4421AA"
                                        showGroupHeaders      = {false} />
                     )
                     :
                     (
                        <div className={styles.noData}>Aucun document</div>
                     )
                   }
                 </div>
               </div>
             </>
           )
  }
  
  


  return (
            
           <div className={classNames(styles.root)}>

               {
                showWindow  &&
                (
                  < Window message                 = {windowMessage}
                           onClickOnValidateButton = {handleCloseButtonClick} />
                )
               }

               {
                staffMemberSheetShow &&
                <StaffMemberSheet users     = {users}
                                  onCancel  = {handleStaffMemberSheetHide}
                                  onConfirm = {handleContactAdding} />
               }

               {
                businessDocumentSheetShow &&
                <BusinessDocumentSheet onCancel  = {handleBusinessDocumentSheetHide}
                                       onConfirm = {handleDocumentAdding} />
               }

               <p className={classNames(styles.title)}>
                 INFORMATIONS 
               </p>

               <br/>

               <div className={classNames(styles.form)}>

               {/*
                 <div className={classNames(styles.userId)}>

                   <WidgetFrame name          = "Id :"
                                error         = {messageFirstname}
                                classNameGrid = {classNames(styles.grid_info)} >

                   {user.id}

                  </WidgetFrame>

                 </div>
               */}
			   
			   

                 <div className={classNames(styles.tradeName)}>
                   <WidgetFrame name               = "Enseigne : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"      
					            error              = {messageTradeName}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field type          = "text"
						    readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {tradeName}
                            onChange      = {handleTradeNameChange} />
                   </WidgetFrame>
				 </div> 

                 <div className={classNames(styles.companyName)}>
                   <WidgetFrame name               = "Nom de l'entreprise : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"      
					            error              = {messageCompanyName}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field type          = "text"
						    readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {companyName}
                            onChange      = {handleCompanyNameChange} />
                   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.legalForm)}>
                   <WidgetFrame name               = "Forme juridique : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageLegalForm}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field type          = "text"
						    readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {legalForm}
                            onChange      = {handleLegalFormChange} />
                   </WidgetFrame>
                 </div>
				 
                 <div className={classNames(styles.businessRegistrationNumber)}>
                   <WidgetFrame name               = "Siret : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"        
					            error              = {messageBusinessRegistrationNumber}
                                classNameGrid      = {classNames(styles.grid_info2)} >
                     <Field type          = "text"
						    readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {businessRegistrationNumber}
                            onChange      = {handleBusinessRegistrationNumberChange} />
                   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.businessActivityCode)}>
                   <WidgetFrame name               = "Code NAF : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageBusinessActivityCode}
                                classNameGrid      = {classNames(styles.grid_info3)} >
                     <Field type          = "text"
						    readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {businessActivityCode}
                            onChange      = {handleBusinessActivityCodeChange} />
                   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.businessSector)}>
                   <WidgetFrame name               = "Secteur d'activité : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageBusinessSector}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field type          = "text"
						    readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {businessSector}
                            onChange      = {handleBusinessSectorChange} />
                   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.businessActivityDetails)}>
                   <WidgetFrame name               = "Détails d'activité : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageBusinessActivityDetails}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field type          = "text"
                            readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {businessActivityDetails}
                            onChange      = {handleBusinessActivityDetailsChange} />
				   </WidgetFrame>
                 </div>
				 
                 <div className={classNames(styles.address)}>
                   <WidgetFrame name               = "Adresse : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageAddress}
                                classNameGrid      = {classNames(styles.grid_info4)} >
                     <TextArea placeholder   = ""
                               readOnly      = {!editMode}
                               value         = {address}
                               onChange      = {handleAddressChange} />
                   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.zipCode)}>
                   <WidgetFrame name               = "Code postal : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageZipCode}
                                classNameGrid      = {classNames(styles.grid_info3)} >
                     <Field type          = "text"
                            readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {zipCode}
                            onChange      = {handleZipCodeChange} />
                   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.city)}>
                   <WidgetFrame name               = "Ville : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageCity}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field type          = "text"
                            readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {city}
                            onChange      = {handleCityChange} />
                   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.country)}>
                   <WidgetFrame name               = "Pays : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageCountry}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Select choices       = { [
                                                    "France",
                                                    "Belgique",
                                                    "Suisse"
                                                  ] }
                             disabled      = {!editMode}
                             value         = {country}
                             onChange      = {handleCountryChange}  
							 placeholder   = "" 
							 width         = "100%" />
                   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.phoneNumber)}>
                   <WidgetFrame name               = "Téléphone : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messagePhoneNumber}
                                classNameGrid      = {classNames(styles.grid_info3)} >
                     <Field type          = "text"
                            readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {phoneNumber}
                            onChange      = {handlePhoneNumberChange} />
                   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.handledByAgentId)}>
                   <WidgetFrame name               = "Suivi par : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageHandledByAgentId}
                                classNameGrid      = {classNames(styles.grid_info3)} >
					 <Select choices       = { adminIds }
                             choicesLabel  = { adminNames }
                             disabled      = {!editMode}
                             value         = { `${handledByAgentId}` }
                             onChange      = { handlehandledByAgentIdChange}
					         placeholder   = ""
							 width         = "100%" />
 				   </WidgetFrame>
                 </div>

                 <div className={classNames(styles.VATnumber)}>
                   <WidgetFrame name               = "N° TVA intracommunautaire : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageVATnumber}
                                classNameGrid      = {classNames(styles.grid_info5)} >
                     <Field type          = "text"
                            readOnly      = {!editMode}
                            placeholder   = ""
                            value         = {VATnumber}
                            onChange      = {handleVATnumberChange} />
                   </WidgetFrame>
                 </div>

                 {/*
                 <div className={classNames(styles.administrativeValidation, styles.frame)}>

                   <div className={styles.header}>
                     <div className={styles.title}>Validation administrative</div> 
                   </div>

                   <div className={classNames(styles.administrativeValidationDate)}>
                     <WidgetFrame name               = "Date : "
                                  labelTextPosition  = "right"
                                  labelBlockPosition = "left"
					              error              = {messageAdministrativeValidationDate}
                                  classNameGrid      = {classNames(styles.grid_info2)} >

                       {
                         (
                           editMode
                         )
                         ?
                         (
                           <FieldCalendar value     = {administrativeValidationDate ? convertDateToString (administrativeValidationDate, 'dd/MM/yyyy') : '' }   
                                          onChange  = {handleAdministrativeValidationDateChange}
										  showHours = {false} />
                         )
                         :
                         (
                           <>{administrativeValidationDate ? convertDateToString (administrativeValidationDate, 'dd/MM/yyyy') : '' }</>
                         )
                       }
                     </WidgetFrame>
                   </div>

                   <div className={classNames(styles.administrativeValidationAgentId)}>
                     <WidgetFrame name               = "Validé par : "
                                  labelTextPosition  = "right"
                                  labelBlockPosition = "left"
					              error              = {messageAdministrativeValidationAgentId}
                                  classNameGrid      = {classNames(styles.grid_info3)} >

                       {
                         (
                           editMode
                         )
                         ?
                         (
						   <Select choices       = { adminIds }
                                   choicesLabel  = { adminNames }
                                   value         = { `${administrativeValidationAgentId}` } 
                                   onChange      = { handleAdministrativeValidationAgentIdChange}   
								   placeholder   = ""  
								   width         = "100%" />
                         )
                         :
                         (
                           <>{getAdministrativeValidationAgentName(administrativeValidationAgentId)}</>
                         )
                       }
                     </WidgetFrame>
                   </div>				   
                 </div>

                 <div className={classNames(styles.financialValidation, styles.frame)}>
				   
                   <div className={styles.header}>
                     <div className={styles.title}>Validation financière</div>
                   </div>
				   
                   <div className={classNames(styles.financialValidationDate)}>
                     <WidgetFrame name               = "Date : "
                                  labelTextPosition  = "right"
                                  labelBlockPosition = "left"
					              error              = {messageFinancialValidationDate}
                                  classNameGrid      = {classNames(styles.grid_info)} >

                       {
                         (
                           editMode
                         )
                         ?
                         (
                           <FieldCalendar value     = {financialValidationDate ? convertDateToString (financialValidationDate, 'dd/MM/yyyy') : ''}   
                                          onChange  = {handleFinancialValidationDateChange}
										  showHours = {false} />
                         )
                         :
                         (
                           <>{financialValidationDate ? convertDateToString (financialValidationDate, 'dd/MM/yyyy') : ''}</>
                         )
                       }
                     </WidgetFrame>
                   </div>
				   
                   <div className={classNames(styles.financialValidationAgentId)}>
                     <WidgetFrame name               = "Validé par : "
                                  labelTextPosition  = "right"
                                  labelBlockPosition = "left"
					              error              = {messageFinancialValidationAgentId}
                                  classNameGrid      = {classNames(styles.grid_info)} >

                       {
                         (
                           editMode
                         )
                         ?
                         (
						   <Select choices       = { adminIds }
                                   choicesLabel  = { adminNames }
                                   value         = { `${financialValidationAgentId}` }
                                   onChange      = { handleFinancialValidationAgentIdChange} 
								   placeholder   = ""  
								   width         = "100%" />
                         )
                         :
                         (
                           <>{getFinancialValidationAgentName(financialValidationAgentId)}</>
                         )
                       }
                     </WidgetFrame>
                   </div>
                   <div className={classNames(styles.financialValidationBalanceValue)}>
                     <WidgetFrame name               = "Encours financier : "
                                  labelTextPosition  = "right"
                                  labelBlockPosition = "left"
					              error              = {messageFinancialValidationBalanceValue}
                                  classNameGrid      = {classNames(styles.grid_info)} >

                       {
                         (
                           editMode
                         )
                         ?
                         (
                           <Field  type          = "text"
                                   placeholder   = ""
                                   value         = {financialValidationBalanceValue}
                                   onChange      = {handleFinancialValidationBalanceValueChange} />
                         )
                         :
                         (
                           <>{financialValidationBalanceValue}</>
                         )
                       }
                     </WidgetFrame>
                   </div>
				   
                   <div className={classNames(styles.financialValidationBalanceExpirationDate)}>
                     <WidgetFrame name               = "Expire le : "
                                  labelTextPosition  = "right"
                                  labelBlockPosition = "left"
					              error              = {messageFinancialValidationBalanceExpirationDate}
                                  classNameGrid      = {classNames(styles.grid_info)} >

                       {
                         (
                           editMode
                         )
                         ?
                         (
                           <FieldCalendar value     = {financialValidationBalanceExpirationDate ? convertDateToString (financialValidationBalanceExpirationDate, 'dd/MM/yyyy') : ''} 
                                          onChange  = {handleFinancialValidationBalanceExpirationDateChange}
										  showHours = {false} />
                         )
                         :
                         (
                           <>{financialValidationBalanceExpirationDate ? convertDateToString (financialValidationBalanceExpirationDate, 'dd/MM/yyyy') : ''}</>
                         )
                       }
                     </WidgetFrame>
                   </div>
				   
                 </div>
				 
				 */}

                 <div className={classNames(styles.contactList, styles.frame)}>
                   {renderContactsTab()}
                 </div>

                 <div className={classNames(styles.documentList, styles.frame)}>
                   {renderDocumentsTab()}
                 </div>

                 <div className={classNames(styles.buttons)}>
                   <div className={classNames(styles.buttons_block)}>
                     {
                       (
                        editMode
                       )
                       ?
                       (
                        <>
                          <Trigger name="Annuler" onClick={handleCancelButtonClick} variant="tailwind2" />
                          &nbsp;&nbsp;&nbsp;
                          <Trigger name="Enregistrer" onClick={handleValidateButtonClick} variant="tailwind2" />
                        </>
                       )
                       :
                       (
                        <Trigger name="Modifier" onClick={handleEditButtonClick} variant="tailwind2" />
                       )
                     }
                  </div>
                 </div>

               </div>

           </div>
           
         );
};


export default LegalStructureSheet;

/*
 *

 - Code Naf
 - Forme juridique
 - Adresse de l'établissement
 - Téléphone
 - adresse email
 - commentaire
 - documents
 - validation financière
 - encours financier
 - contacts (tableau 1 contact par ligne id, nom prénom fonction téléphone email)
 - secteur d'activité
 - détails d'activité
 - CA cumulé
*/
